import { render, staticRenderFns } from "./HuoDong.vue?vue&type=template&id=3382bd38&scoped=true&"
import script from "./HuoDong.vue?vue&type=script&lang=js&"
export * from "./HuoDong.vue?vue&type=script&lang=js&"
import style0 from "./HuoDong.vue?vue&type=style&index=0&id=3382bd38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3382bd38",
  null
  
)

export default component.exports